import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useState } from "react";
import { X } from "lucide-react";
import FloatingADUWizard from "@/components/FloatingADUWizard";
import FloatingReserveButton from "@/components/FloatingReserveButton";
import CanonicalTag from "@/components/CanonicalTag";

const SpanishColonialADUDesignMountainView = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Spanish Colonial ADU Design & Construction in Mountain View",
    "description": "Create authentic Spanish Colonial ADUs in Mountain View with traditional features and modern amenities.",
    "publisher": {
      "@type": "Organization",
      "name": "UDA ADU"
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <CanonicalTag url="https://www.udaadu.com/spanish-colonial-adu-design-mountain-view" />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <Navigation />

      {/* Calendly Modal */}
      {showCalendly && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative w-full max-w-2xl h-[70vh] bg-white rounded-lg overflow-hidden shadow-xl">
            <button onClick={closeCalendlyModal} className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors">
              <X className="h-6 w-6 text-gray-600" />
            </button>
            <iframe src="https://calendly.com/udaadu?embed=true&hide_gdpr_banner=1" width="100%" height="100%" frameBorder="0" title="Schedule a meeting" />
          </div>
        </div>
      )}

      <main className="max-w-6xl mx-auto px-4 py-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-white">
            Spanish Colonial ADU Design & Construction in Mountain View
          </h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Create authentic Spanish Colonial ADUs in Mountain View with traditional features and modern amenities.
          </p>
        </div>

        <div className="text-center">
          <Button onClick={openCalendlyModal} size="lg" className="mr-4">
            Schedule Consultation
          </Button>
          <Button asChild variant="outline" size="lg" className="text-white border-white hover:bg-white hover:text-black">
            <Link to="/adu-calculator">Get Cost Estimate</Link>
          </Button>
        </div>
      </main>

      <FloatingADUWizard />
      <FloatingReserveButton />
      <Footer />
    </div>
  );
};

export default SpanishColonialADUDesignMountainView;